import { spiritoryWebApi } from '@/lib/axios/spiritoryWebApi';
import {
  BaseApiResponse,
  SkuAPI,
  SpiritoryWebEndpoints,
} from '@/types/api/api-v2';

export default async function getMultipleSkus(
  skus: string[],
  limit: number
): Promise<SkuAPI[]> {
  try {
    const finalURL =
      `/sku/multiple?slugs=${skus.join(',')}&limit=${limit}` as SpiritoryWebEndpoints;
    const {
      data: { data },
    } = await spiritoryWebApi.get<BaseApiResponse<SkuAPI[]>>(finalURL);

    return data;
  } catch (error: unknown) {
    throw error;
  }
}
